import { render, staticRenderFns } from "./deleteStaff.vue?vue&type=template&id=3e33fcef&scoped=true"
import script from "./deleteStaff.vue?vue&type=script&lang=js"
export * from "./deleteStaff.vue?vue&type=script&lang=js"
import style0 from "./deleteStaff.vue?vue&type=style&index=0&id=3e33fcef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e33fcef",
  null
  
)

export default component.exports